<div *ngIf="staticMapUrl; else loading">
  <img [src]="staticMapUrl" alt="Ruta" />
</div>

<ng-template #loading>
  <p>Učitavanje mape...</p>
</ng-template>
